import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "month_arrow_r",
  "use": "month_arrow_r-usage",
  "viewBox": "0 0 8 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 12\" id=\"month_arrow_r\"><path d=\"M.59 10.59L2 12l6-6-6-6L.59 1.41 5.17 6 .59 10.59z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol